import { useNavigate } from "react-router-dom";
import { useGetRequest } from "../../../../Utils/hooks/QueryHandler";
import useLocalStorageState from "use-local-storage-state";
import nodata from "../../../../Utils/assets/img/leads_no_data_found.png";
import { IconTrash, IconCheck, IconCalendar, IconPencilPlus, IconFilter, IconBell, IconClock } from "@tabler/icons-react";
import { useState, useEffect } from "react";
import { PutRequest } from "../../../../Utils/hooks/ApiHandler";
import { toast } from "sonner";
import DeleteModal from "../../../DeleteModal";
import { Dropdown } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { AddTodoModal } from "./AddTodoModal";
import { formatDate, getValueOrDash } from "../../../../Utils/helpers/commonhelper";

export const MyTodos = ({ filter, }) => {
    const [customer, setCustomer] = useLocalStorageState("customer", { token: {} });
    const customer_id = customer?.customer_details?.customer_id;
    const token = customer?.token?.authorization;
    const rf = customer?.token?.authentication;
    const headers = { Authorization: token, Authentication: rf };
    const navigate = useNavigate();
    const extras = { customer, setCustomer, rf, navigate };
    const user_login_id = customer?.customer_details?.id;
    const brandColor = "#7a3a5e";

    const [todoFilter, setTodoFilter] = useState('incomplete')
    const [addTodo, setAddTodo] = useState(false)
    const [refreshTodos, setRefreshTodos] = useState(0)

    const [todoDate, setTodoDate] = useState("")
    const [showCalendar, setShowCalendar] = useState(false)


    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteTodoId, setDeleteTodoId] = useState(null);
    const [loading, setLoading] = useState(false);

    const { data: todoData, refetch } = useGetRequest(
        `taskboard/fetchTodo/${customer_id}/${user_login_id}?filter=${todoFilter}`,
        ["fetchTodos", todoFilter],
        headers,
        extras
    );

    const [completed, setCompleted] = useState({});

    useEffect(() => {
        if (refreshTodos) {
            refetch();
            setRefreshTodos(0);
        }
    }, [refreshTodos]);

    useEffect(() => {
        if (todoData?.data) {
            const initial = {};
            todoData.data.forEach(todo => {
                initial[todo.id] = todo.status === "complete";
            });
            setCompleted(initial);
        }
    }, [todoData]);

    const toggleComplete = (id) => {
        setCompleted(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const handleStatusChange = async (status, todoId) => {
        const isDelete = status === 'delete';
        try {
            if (isDelete) setLoading(true);

            const payload = {
                customer_id,
                todo_id: todoId,
                user_login_id,
                status: status ? isDelete ? "delete" : "complete" : "incomplete"
            };

            const res = await PutRequest(`taskboard/changeStatusOfTodo`, payload, { headers }, extras);

            if (res.status === "fail" || res.success === false) {
                toast.error(res.message);
                return;
            }

            refetch();
            toast.success(res.message);
            if (isDelete) {
                setDeleteModal(false);
                setDeleteTodoId(null);
            }

        } catch (error) {
            toast.error("Something went wrong");
        } finally {
            if (isDelete) setLoading(false);
        }
    };

    return (
        <div className="bg-white rounded-4 border shadow-sm overflow-hidden d-flex flex-column" style={{ height: "calc(100vh - 12rem)" }}>

            {/* 1. Header Control Belt Component */}
            <div className="px-4 py-3 bg-light-subtle border-bottom d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-flex-column align-items-center">
                    <h6 className="mb-0" style={{ textTransform: "capitalize", fontWeight: 400 }}>Todo Checklist</h6>
                    <span className="text-muted" style={{ fontSize: "12px" }}>Manage your dynamic day-to-day items</span>
                </div>

                {/* Inline Controls (Filter, Calendar Picker, Add Action) */}
                <div className="d-flex align-items-center gap-2">

                    {/* Status Segment Filter Dropdown */}
                    <Dropdown style={{ zIndex: 99, }}>
                        <Dropdown.Toggle
                            as={'button'}
                            id="todo-status-dropdown"
                            className="btn btn-sm d-flex align-items-center border gap-2 px-3 py-2 text-secondary no-arrow"
                            style={{ borderRadius: "8px" }}
                        >
                            <IconFilter size={16} style={{ color: brandColor }} />
                            <span className="text-capitalize">{todoFilter === "incomplete" ? "Incompleted Todos" : `${todoFilter}ed Todos`}</span>
                            <i className="fa-solid fa-chevron-down align-middle ms-1 d-inline-block"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="shadow" style={{ zIndex: 9999, marginTop: "3px" }} align={"end"}>
                            <Dropdown.Item onClick={() => setTodoFilter("incomplete")}>Incompleted Todos</Dropdown.Item>
                            <Dropdown.Item onClick={() => setTodoFilter("complete")}>Completed Todos</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    {/* Primary Creation Action Button */}
                    <button
                        className="btn btn-sm text-white d-flex align-items-center gap-1 px-3 py-2 fw-semibold shadow-sm hover-brightness"
                        style={{ backgroundColor: brandColor, borderRadius: "8px" }}
                        onClick={() => setAddTodo(true)}
                    >
                        <IconPencilPlus size={16} />
                        <span>Add Todo</span>
                    </button>
                </div>
            </div>

            {/* 2. Responsive Borderless Scroll List Container */}
            <div className="flex-grow-1 overflow-auto">
                <table className="table table-hover align-middle mb-0" style={{ minHeight: "calc(100vh - 10rem)" }}>
                    <thead className="bg-light-subtle border-bottom sticky-top" style={{ zIndex: 5, background: "#f8fafc" }}>
                        <tr>
                            <th className="" style={{ width: "20px" }}></th>
                            <th className=" " style={{ minWidth: "150px" }}>Todo Details</th>
                            <th className=" " style={{ width: "120px" }}>Priority</th>
                            <th className=" " style={{ width: "140px" }}>Due Date</th>
                            <th className=" " style={{ width: "110px" }}>Due Time</th>
                            <th className=" " style={{ width: "110px" }}>Created At</th>
                            <th className=" " style={{ width: "130px" }}>Reminder Before</th>
                            <th className="text-end pe-4" style={{ width: "80px" }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody className="position-relative">
                        {todoData?.data && todoData?.data?.length > 0 ? (
                            todoData?.data?.map((todo, index) => {
                                const isDone = !!completed[todo.id];
                                return (
                                    <tr key={todo.id} className={`todo-row ${isDone ? 'is-completed' : ''}`}>
                                        <td >
                                            <div
                                                className={`custom-cb ${isDone ? 'checked' : ''}`}
                                                onClick={() => {
                                                    const newStatus = !isDone;
                                                    toggleComplete(todo.id);
                                                    handleStatusChange(newStatus, todo.id);
                                                }}
                                            >
                                                {isDone && <IconCheck size={12} color="white" stroke={3} />}
                                            </div>
                                        </td>

                                        {/* Dynamic Text Row */}
                                        <td className="w-50">
                                            <span className="strikethrough fw-semibold text-dark" style={{ fontSize: '14px' }}>
                                                {getValueOrDash(todo.title)}
                                            </span>
                                        </td>

                                        <td>
                                            <PriorityBadge priority={getValueOrDash(todo.priority)} />
                                        </td>

                                        {/* Core Properties */}
                                        <td className="text-secondary fw-medium" style={{ fontSize: '13px' }}>{getValueOrDash(formatDate(todo.due_date)) || "-"}</td>
                                        <td className="text-secondary fw-medium" style={{ fontSize: '13px' }}>{getValueOrDash(todo.due_time)}</td>

                                        <td className="text-secondary fw-medium" style={{ fontSize: '13px' }}>{getValueOrDash(formatDate(todo.created_at?.split(" ")[0]))}</td>

                                        {/* New Core Column: Reminder Display */}
                                        <td className="text-secondary" style={{ fontSize: '13px' }}>
                                            {todo.reminderBefore ? (
                                                <span className=" bg-light fw-medium border px-2 py-1 rounded-2">
                                                    {todo.reminderBefore} mins
                                                </span>
                                            ) : (
                                                <span className="text-muted opacity-50">-</span>
                                            )}
                                        </td>

                                        {/* Action Operations */}
                                        <td className="text-end pe-4">
                                            <button
                                                onClick={() => {
                                                    setDeleteTodoId(todo.id);
                                                    setDeleteModal(true);
                                                }}
                                                className="btn-action-delete p-2 rounded-2 ms-auto d-flex align-items-center justify-content-center"
                                            >
                                                <IconTrash size={16} stroke={1.5} />
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            /* Fixed Table HTML Compliance: Spanned empty state row wrapper */
                            <div
                                class="d-flex justify-content-center align-items-center"
                                style={{ position: "absolute", left: " 42%", top: '25%' }}
                            >
                                <img
                                    src={nodata}
                                    alt=""
                                    style={{ width: "17rem", marginTop: "0" }}
                                />
                            </div>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Scope Isolated CSS Injections */}
            <style jsx>{`
                .todo-row { transition: all 0.2s ease; border-bottom: 1px solid #f1f5f9; }
                .todo-row:hover { background-color: #f8fafc; }
                .todo-row.is-completed { background-color: #fafafa; opacity: 0.65; }
                
                .strikethrough {
                    position: relative;
                    display: inline-block;
                    transition: color 0.2s ease;
                }
                .strikethrough::after {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 50%;
                    width: 0;
                    height: 1.5px;
                    background: #64748b;
                    transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
                }
                .is-completed .strikethrough::after { width: 100%; }
                .is-completed .strikethrough { color: #94a3b8 !important; font-weight: 500 !important; }

                .custom-cb {
                    width: 18px;
                    height: 18px;
                    border: 2px solid #cbd5e1;
                    border-radius: 5px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.15s ease;
                }
                .custom-cb:hover { border-color: ${brandColor}; background-color: ${brandColor}10; }
                .custom-cb.checked {
                    background-color: ${brandColor};
                    border-color: ${brandColor};
                }

                .btn-action-delete {
                    background: transparent;
                    border: none;
                    color: #94a3b8;
                    transition: all 0.2s ease;
                }
                .btn-action-delete:hover {
                    background-color: #fee2e2;
                    color: #ef4444;
                }
                .hover-brightness:hover {
                    filter: brightness(1.15);
                }
                .dropdown-toggle::after {
                    display: inline-block;
                    margin-left: 0.455em;
                    vertical-align: 0.255em;
                    content: "";
                    border-top: 0.3em solid;
                    border-right: 0.3em solid transparent;
                    border-bottom: 0;
                    border-left: 0.3em solid transparent;
                }
            `}</style>
            {
                addTodo && (
                    <AddTodoModal
                        show={addTodo}
                        onClose={() => setAddTodo(false)}
                        onSuccess={() => {
                            setRefreshTodos(prev => prev + 1);
                            setAddTodo(false);
                        }}
                    />
                )
            }


            <DeleteModal
                isLoading={loading}
                show={deleteModal}
                onClose={() => {
                    setLoading(false);
                    setDeleteTodoId(null);
                    setDeleteModal(false);
                }}
                onConfirm={() => handleStatusChange('delete', deleteTodoId)}
                message={"Are you sure you want to delete this todo?"}
            />
        </div >
    );
};

/* Isolated Micro Variant Component Styling For Table Content Badges */
const PriorityBadge = ({ priority }) => {
    let styles = { bg: "#f1f5f9", color: "#475569" };
    const p = priority?.toLowerCase();
    if (p === "high") styles = { bg: "#fff1f2", color: "#e11d48", border: "#ffe4e6" };
    if (p === "medium") styles = { bg: "#fef3c7", color: "#d97706", border: "#fde68a" };
    if (p === "low") styles = { bg: "#f0fdf4", color: "#16a34a", border: "#dcfce7" };

    return (
        <span className="badge" style={{
            backgroundColor: styles.bg,
            color: styles.color,
            border: `1px solid ${styles.border || 'transparent'}`,
            fontSize: '11px',
            fontWeight: '600',
            padding: '4px 8px',
            borderRadius: '6px',
            textTransform: 'capitalize'
        }}>
            {priority || "Normal"}
        </span>
    );
};